'use strict';

import React from 'react';
import {observer} from "mobx-react";

import Card from 'react-bootstrap/Card';

import {useAppContext} from '@uw-it-sis/lib-react/lib/AppContext';
import DocumentTitle from '@uw-it-sis/lib-react/lib/DocumentTitle';

import PlanSharedSelector from '@uw-it-sis/lib-react-myplan/lib/PlanSharedSelector';

import Majors from "./Majors";
import Notify from "./Notify";

const Account = () => {
    const appStore = useAppContext().appStore;
    const ProviderIcon = appStore.getAuthenticationProviderIcon();

    let importPlan, planShare;

    // Give info to social users about ability to import plan in future
    if ( appStore.isSocialUser() ) {
        importPlan =
            <>
                <p>If you're using MyPlan with a Google login, you will be able to import your academic
                    plan to your official UW account once you are accepted to the University of Washington. Note:
                    This will overwrite any plan you create with your UW NetID account.</p>
                <p><a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/import-plan/" target="_blank">Learn
                    more about
                    importing your plan</a>.</p>
            </>
    }

    // We should only display social Import Link and plan Shared Selector for UW students.
    if ( ! appStore.isSocialUser() ) {
        importPlan =
            <>
                <p>Import an academic plan you created with your Google account.</p>
                <p><strong>Note:</strong> This will overwrite any plan you have created with your
                    UW NetID account. <a
                        href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/import-plan/"
                        target="_blank">Learn more about importing the plan</a>.</p>
                <p><a href="/plan/#/import" className="fw-bold">Start the import process</a></p>
            </>

        planShare =
            <Card bg="transparent" className="border">
                <Card.Header>
                    <Card.Title as="h2" className="mb-0">MyPlan Privacy Settings</Card.Title>
                </Card.Header>
                <Card.Body>
                    <PlanSharedSelector/>
                </Card.Body>
            </Card>;
    }

    return (
        <DocumentTitle title="Account - MyPlan">
            <>
                <div className="page-heading">
                    <h1>Account</h1>
                </div>
                <div className="d-flex flex-column gap-4">
                    <Card bg="transparent" className="border">
                        <Card.Header>
                            <Card.Title as="h2" className="mb-0">User Name</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <dl className="row mb-0 description-term-colon">
                                <dt className="col-12 col-md-2 text-start mb-0">Signed in as</dt>
                                <dd className="col-12 col-md-3 mb-0">
                                    <ProviderIcon className="me-2 fs-5" />
                                    <span>{appStore.getUserName()}</span>
                                </dd>
                            </dl>
                        </Card.Body>
                    </Card>
                    <Majors />
                    <Card bg="transparent" className="border">
                        <Card.Header>
                            <Card.Title as="h2" className="mb-0">Import Plan from Another Account</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {importPlan}
                        </Card.Body>
                    </Card>
                    <Notify />
                    {planShare}
                </div>
            </>
        </DocumentTitle>
    );
}

export default observer(Account);